const orderIDPopupCopy = {
  popupCopyToClipboard: 'Right-click to copy Order ID to clipboard.',
  popupCopySuccess: 'Order ID copied to clipboard!',
  popupCopyFailure: 'Copy error.'
};

export default orderIDPopupCopy;
